module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_feeling05-3f8e36cfffbde56daa19f3455b522210.svg";